// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.users-form {
  display: flex;
}
.users-form .left-side,
.users-form .right-side {
  flex: 1;
  padding: 0 20px;
}
.users-form .right-side {
  display: flex;
  flex-direction: column;
  border-left: 1px solid #c5c5c5;
}
.users-form .right-side h2 {
  padding: 0 20px;
}

mat-toolbar {
  margin: 5px 0;
}

mat-dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

mat-dialog-actions {
  justify-content: flex-end;
}

.error-tooltip {
  position: absolute;
  right: 5px;
  bottom: 115%;
  background-color: #555;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  color: #ffffff;
}
.error-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.error-tooltip .span-error::after {
  content: ",";
}
.error-tooltip .span-error:last-child::after {
  content: "";
}

mat-panel-title,
mat-panel-description {
  flex: 1;
  display: flex;
  align-items: center;
}

.pointer-none {
  pointer-events: none;
}

.content .letter {
  display: inline-block;
}
.content .letter::before {
  content: " ";
}
.content .letter::after {
  content: ",";
}
.content .letter:last-child::after {
  content: "";
}`, "",{"version":3,"sources":["webpack://./src/app/pages/users/users-form/users-form.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;AAEF;AAAE;;EAEE,OAAA;EACA,eAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACJ;AACI;EACE,eAAA;AACN;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AADF;AAGE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;AADJ;AAKI;EACE,YAAA;AAHN;AAOM;EACE,WAAA;AALR;;AAWA;;EAEE,OAAA;EACA,aAAA;EACA,mBAAA;AARF;;AAWA;EACE,oBAAA;AARF;;AAYE;EACE,qBAAA;AATJ;AAWI;EACE,YAAA;AATN;AAYI;EACE,YAAA;AAVN;AAcM;EACE,WAAA;AAZR","sourcesContent":[".users-form {\r\n  display: flex;\r\n\r\n  .left-side,\r\n  .right-side {\r\n    flex: 1;\r\n    padding: 0 20px;\r\n  }\r\n\r\n  .right-side {\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-left: 1px solid #c5c5c5;\r\n\r\n    h2 {\r\n      padding: 0 20px;\r\n    }\r\n  }\r\n}\r\n\r\nmat-toolbar {\r\n  margin: 5px 0;\r\n}\r\n\r\nmat-dialog-content {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nmat-dialog-actions {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.error-tooltip {\r\n  position: absolute;\r\n  right: 5px;\r\n  bottom: 115%;\r\n  background-color: #555;\r\n  padding: 5px 10px;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n  color: #ffffff;\r\n\r\n  &::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 50%;\r\n    margin-left: -5px;\r\n    border-width: 5px;\r\n    border-style: solid;\r\n    border-color: #555 transparent transparent transparent;\r\n  }\r\n\r\n  .span-error {\r\n    &::after {\r\n      content: ','\r\n    }\r\n\r\n    &:last-child {\r\n      &::after {\r\n        content: ''\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nmat-panel-title,\r\nmat-panel-description {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pointer-none {\r\n  pointer-events: none;\r\n}\r\n\r\n.content {\r\n  .letter {\r\n    display: inline-block;\r\n\r\n    &::before {\r\n      content: '\\00a0'\r\n    }\r\n\r\n    &::after {\r\n      content: ','\r\n    }\r\n\r\n    &:last-child {\r\n      &::after {\r\n        content: ''\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
